import apiService from "./apiService";

const salesService = {
    getLast6MonthsSales: async () => {
        const response = await apiService.get(`/sales/last6Months`);
        return response;
    },
    getInvoices: async(beginMonth: string, endMonth: string, offset: number, count: number) => {
        const response = await apiService.get(`/sales/invoices?billingPeriodStart=${beginMonth}&billingPeriodEnd=${endMonth}&status=all&offset=${offset}&count=${count}`);
        return response;
    }
}
export default salesService;